const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/KontaktPerson.tsx';
import React, { forwardRef } from 'react';
import _ from 'lodash';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { CIS4mPhoneNumberField } from '@cistec/common_web/modules/CIS4m/components/CIS4mPhoneNumberField';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { validatePhoneNumber } from '@cistec/common_web/components/Forms/utils/validation';
import textMapCommon from '../../../common/translations';
import textMap from 'App/config/uster/eCheckin/translations';
import { createFieldPath } from 'App/components/eCheckin/utils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { BeziehungField } from 'App/components/eCheckin/components/fields/metakat/BeziehungField';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_NOT_SPECIFIED = createFieldPath(path, 'notSpecified');
    const PATH_RELATION = createFieldPath(path, 'relation');
    const PATH_FIRST_NAME = createFieldPath(path, 'firstname');
    const PATH_LAST_NAME = createFieldPath(path, 'lastname');
    const PATH_COUNTRY = createFieldPath(path, 'country');
    const PATH_TEL = createFieldPath(path, 'tel');

    const formData = useCIS4mData();
    const keineAngaben = _.get(formData, PATH_NOT_SPECIFIED) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={props.path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.notSpecified} path={PATH_NOT_SPECIFIED} />
            <CIS4mBlock hidden={keineAngaben}>
                <BeziehungField label={textMap.relation} path={PATH_RELATION} required={true} />
                <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required={true} />
                <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required={true} />
                <AddressBlock basePath={props.path} required={true} fieldsConfig={addressFieldsConfig} />
                <CIS4mPhoneNumberField
                    label={textMap.tel}
                    path={PATH_TEL}
                    required={true}
                    checkValidity={validatePhoneNumber}
                    countryCodePath={PATH_COUNTRY}
                />
            </CIS4mBlock>
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
